import Vue from 'vue';
import VueLazyload from 'vue-lazyload';

Vue.use(VueLazyload, {
	preLoad: 1.3,
	error: 'img/brand/avatar.jpg',
	loading: 'img/brand/tenor.gif',
	attempt: 1
});
